import $axios from "../../api/axios";

function getAdsApi({ params, callback }) {
  $axios
    .post(`/api/getAdvertising`, params.other)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getSearchSuburbsDropdownApi({ params, callback }) {
  $axios
    .post(`/api/house/getSuburbsSearchDropdown`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}
function getAllStatesApi({ params, callback }) {
  $axios
    .get(`/api/house/getAllStates`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getListApi({ params, callback }) {
  $axios
    .post(`/api/house/${params.page}/${params.pageSize}`, params.other)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function postCollectApi({ params, callback }) {
  let form = new FormData();
  form.append("propertyId", params.propertyId);
  $axios
    .post(`/api/user/favorites`, form)
    .then(res => {
      callback(res, params.propertyId);
    })
    .catch(err => {
      console.log(err);
    });
}

function cancelCollectApi({ params, callback }) {
  $axios
    .delete(`/api/user/favorites?propertyId=${params.propertyId}`)
    .then(res => {
      callback(res, params.propertyId);
    })
    .catch(err => {
      console.log(err);
    });
}

function signApi({ params, callback }) {
  $axios
    .post(`/api/sign`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function agreeApi({ param, callback }) {
  $axios
    .get(`/api/agreement/${param}`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getAdsApi,
  getListApi,
  getSearchSuburbsDropdownApi,
  postCollectApi,
  cancelCollectApi,
  signApi,
  agreeApi,
  getAllStatesApi,
};



// WEBPACK FOOTER //
// ./src/api/home/home.js